// components/CenteredAvatar.jsx
import { Image } from "react-bootstrap";

export default function CenteredAvatar({ src, size = 150, alt = "Avatar" }) {
    if (src) {
        return (
            <Image
                src={src}
                roundedCircle
                style={{ width: size, height: size, objectFit: "cover" }}
                className="mb-3 mx-auto d-block"
                alt={alt}
            />
        );
    }
    return (
        <div
            style={{
                width: size, height: size, borderRadius: "50%",
                background: "#f1f1f1", display: "flex",
                justifyContent: "center", alignItems: "center", margin: "0 auto",
            }}
        >
            <svg
                width={Math.round(size * 0.42)}
                height={Math.round(size * 0.42)}
                viewBox="0 0 16 16"
                fill="#dc3545"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="M8 9a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm4.285 1.567C11.36 9.6 9.77 9 8 9s-3.36.6-4.285 1.567A2.5 2.5 0 0 0 3 13.5V14h10v-.5a2.5 2.5 0 0 0-0.715-1.933z" />
            </svg>
        </div>
    );
}